// extracted by mini-css-extract-plugin
module.exports = {"button":"button-module--button--1WU8w","fontsLoading":"button-module--fonts-loading--3Xdi1"};